
import {of as observableOf,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { FeatureFlagsService } from 'src/common/services/feature-flags/feature-flags.service';

@Injectable()
export class FeatureFlagsCanActivateGuard  {

  constructor(private featureFlagsService: FeatureFlagsService) {}
  
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (this.featureFlagsService
      && route
      && route.data
      && route.data.featFlags) {
      return this.featureFlagsService.isFeatureActive(route.data.featFlags);
    }
    return observableOf(false);
  }
}
